import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { io } from 'socket.io-client';
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Paper,
  useTheme,
  CircularProgress,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import {
  getDecryptedAccessToken,
  getDecryptedData,
  getDecryptedUserType,
} from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';

const SenMessages = ({ patient }) => {
  const [message, setMessage] = useState('');
  const [chat, setChat] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
const socketRef = useRef(null);
const messageEndRef = useRef(null);
const theme = useTheme();
console.log("patient",patient)
const LoginUserDetails = getDecryptedData();
const LoginUserType = getDecryptedUserType();
const AccessToken = getDecryptedAccessToken();

const API_BASE = 'http://18.191.236.218/riteclinic-openemr/apis/default';
const routePrefix = LoginUserType === 'Patient' ? 'portal' : 'api';

const senderId =
LoginUserType === 'Patient' ? LoginUserDetails.pid : LoginUserDetails.id;
const receiverId =
LoginUserType === 'Patient' ? patient?.id : patient?.pid;
    
  const fetchMessages = async () => {
    setLoading(true);
    setError(false);
    try {
      const res = await axios.get(
        `${API_BASE}/${routePrefix}/chat/${receiverId}/patient/${senderId}`,
        {
          headers: { Authorization: `Bearer ${AccessToken}` },
        }
      );
      const data = res.data || [];
      console.log("res",res.data)
      setChat(data);
    } catch (err) {
      console.error('Fetch error:', err?.response || err);
      setChat([]);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const sendMessage = async () => {
    if (!message.trim()) return;

    const newMessage = {
      sender: senderId,
      receiver_id: receiverId,
      pid: LoginUserType === 'Patient' ? LoginUserDetails.pid : patient?.pid,
      message: message.trim(),
      sender_type: LoginUserType === 'Patient' ? 'patient' : 'user',
      receiver_type: LoginUserType === 'Patient' ? 'user' : 'patient',
    };

    try {
      await axios.post(`${API_BASE}/${routePrefix}/chatsend`, newMessage, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AccessToken}`,
        },
      });

      // Show immediately
      setChat((prev) => [...prev, {
        sender: senderId,
        receiver_id: receiverId,
        body: message.trim()
      }]);

      socketRef.current?.emit('chat', newMessage);
      console.log("newMessage",newMessage)
      setMessage('');
    } catch (err) {
      console.error('Send error:', err?.response || err);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  useEffect(() => {
    if (!senderId || !receiverId) return;

    socketRef.current = io('http://18.191.236.218:4001');

    socketRef.current.on('connect', () => {
      socketRef.current.emit('join', {
        userId: senderId,
        userType: LoginUserType,
        groups: [],
      });
    });

    socketRef.current.on('chat', (data) => {
      if (String(data.sender) !== String(senderId)) {
        setChat((prev) => [...prev, data]);
      }
    });

    socketRef.current.on('disconnect', () => {
      console.warn('Socket disconnected');
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, [senderId, receiverId]);

  useEffect(() => {
    if (senderId && receiverId) fetchMessages();
  }, [senderId, receiverId]);

  useEffect(() => {
    messageEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chat]);

  return (
    <Paper
      elevation={3}
      sx={{
        maxWidth: "100%",
        height: '93vh',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 3,
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <Box sx={{ p: 2, backgroundColor: theme.palette.primary.main, color: '#fff' }}>
        <Typography variant="h6">Chat with {patient?.fname || patient?.name || 'User'}</Typography>
      </Box>

      {/* Chat Body */}
      <Box
        sx={{
          flexGrow: 1,
          p: 2,
          overflowY: 'auto',
          backgroundColor: '#f4f6f8',
        }}
      >
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <CircularProgress size={24} />
          </Box>
        ) : error ? (
          <Typography variant="body2" color="text.secondary">
            No chat history found.
          </Typography>
        ) : chat.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No messages found.
          </Typography>
        ) : (
          chat.map((msg, index) => {
            const isSender = String(msg.user || msg.sender) == String(senderId);
            return (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  justifyContent: isSender ? 'flex-end' : 'flex-start',
                  mb: 1,
                }}
              >
                <Box
                  sx={{
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    maxWidth: '70%',
                    backgroundColor: isSender ? theme.palette.primary.main : '#e0e0e0',
                    color: isSender ? '#fff' : '#000',
                    wordBreak: 'break-word',
                  }}
                >
                  <Typography variant="body2">
                    {msg.message || msg.body || 'No content'}
                  </Typography>
                </Box>
              </Box>
            );
          })
        )}
        <div ref={messageEndRef} />
      </Box>

      {/* Chat Input */}
      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          sendMessage();
        }}
        sx={{
          p: 1.5,
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#fff',
          borderTop: '1px solid #ccc',
        }}
      >
        <TextField
          fullWidth
          size="small"
          placeholder="Type a message"
          variant="outlined"
          value={message}
          multiline
          maxRows={3}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyPress}
          sx={{ mr: 1 }}
        />
        <IconButton type="submit" color="primary">
          <SendIcon />
        </IconButton>
      </Box>
    </Paper>
  );
};

export default SenMessages;
